import React, { useState, useEffect, useMemo, useRef } from "react";

import Sidebar from "./Sidebar";

import TopBar from "./TopBar";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import assignedCandidateList from "../../assets/images/reportImageOne.png";

import mailIcon from "../../assets/images/MailIconViolet.png";

import TopNavbar from "../top-navbar/TopNav";

import { CiSearch } from "react-icons/ci";

import { FaEye } from "react-icons/fa";

import { ArrowLeft } from "lucide-react";

import ReportPage from "../ClientModule/Report";

import "../../styles/employee/assigned-candidates.css";

import { toast } from "react-toastify";

import { updateCandidateStatus } from "../../services/employee/api";

import {
  getCachedAssignedCandidates,
  clearAssignedCandidatesCache,
} from "../../services/employee/cache";

import { useParams } from "react-router-dom";

import {
  getBGCButtonLabel,
  isBGCButtonDisabled,
} from "../../utils/bgc status/BgcstatusForAssignedCandidateList";

import { isMailButtonDisabled } from "../../utils/bgc status/mailButtonDisable";

const EyeIcon = () => <span className="material-icons"></span>;

const MailIcon = () => <span className="mail-icon-purple">✉️</span>;
const MAX_PAGE_SIZE = 100;
const PARALLEL_BATCH = 5;

const AssignedCandidatesList = () => {
  const { status } = useParams();

  const [searchTerm, setSearchTerm] = useState("");

  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);

  const [candidates, setCandidates] = useState([]);

  const [totalCandidates, setTotalCandidates] = useState(0);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  const [loadingProfile, setLoadingProfile] = useState(false);

  const navigate = useNavigate();

  const token = localStorage.getItem("bgc_token");

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "desc",
  });

  const requestIdRef = useRef(0);


  const trimmedSearch = searchTerm.trim();
  const isSearching = trimmedSearch !== "";

  const getBackendSortField = (key) => {
    switch (key) {
      case "uniqueId":
        return "candidateId";

      case "name":
        return "fullName";

      case "email":
        return "email";

      case "status":
        return "currentBgcStatus";

      default:
        return "candidateId";
    }
  };

  const mapCandidate = (candidate) => ({
    id: candidate.candidateid,
    uniqueId: candidate.candidateid,
    name: candidate.name,
    email: candidate.email,
    status: candidate.bgcStatus || "Unknown",
    statusResponse: candidate.statusResponse || {},
    uanCheckStatus: candidate.uanCheckStatus,
    criminalCheckStatus: candidate.criminalCheckStatus,
  });

  const fetchAllCandidates = async (requestId, sortField, sortDirection) => {
    const firstResponse = await getCachedAssignedCandidates(
      status,
      0,
      MAX_PAGE_SIZE,
      sortField,
      sortDirection,
    );

    if (requestId !== requestIdRef.current) return null;

    const firstData = firstResponse?.data?.data;

    if (!firstData) {
      return { list: [], total: 0 };
    }

    const total = firstData.totalCandidates || 0;
    let all = [...(firstData.candidateDTOList || [])];

    const totalBackendPages = Math.ceil(total / MAX_PAGE_SIZE);

    for (let start = 1; start < totalBackendPages; start += PARALLEL_BATCH) {
      const end = Math.min(start + PARALLEL_BATCH, totalBackendPages);

      const requests = [];
      for (let page = start; page < end; page++) {
        requests.push(
          getCachedAssignedCandidates(
            status,
            page,
            MAX_PAGE_SIZE,
            sortField,
            sortDirection,
          ),
        );
      }

      const responses = await Promise.all(requests);

      if (requestId !== requestIdRef.current) return null;

      responses.forEach((res) => {
        const list = res?.data?.data?.candidateDTOList || [];
        all = all.concat(list);
      });
    }

    return { list: all, total };
  };

  const fetchCandidates = async () => {
    const requestId = ++requestIdRef.current;

    setLoading(true);
    setError(null);

    const token = localStorage.getItem("bgc_token");

    if (!token) {
      setError("Authentication token not found. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const backendSortField = getBackendSortField(sortConfig.key);

      if (isSearching) {
        const result = await fetchAllCandidates(
          requestId,
          backendSortField,
          sortConfig.direction,
        );


        if (!result) return;

        setCandidates(result.list.map(mapCandidate));

        setTotalCandidates(result.total);
      } else {
        const response = await getCachedAssignedCandidates(
          status,
          currentPage - 1,
          entriesPerPage,
          backendSortField,
          sortConfig.direction,
        );

        if (requestId !== requestIdRef.current) return;

        if (response.data && response.data.data) {
          const responseData = response.data.data;

          const candidateList = responseData.candidateDTOList || [];

          setCandidates(candidateList.map(mapCandidate));

          setTotalCandidates(responseData.totalCandidates || 0);
        } else {
          setCandidates([]);
          setTotalCandidates(0);
        }
      }
    } catch (err) {
      if (requestId !== requestIdRef.current) return;

      if (err.response?.status === 404) {
        setCandidates([]);
        setTotalCandidates(0);
        setError(null);
      } else {
        setError(
          err.response?.data?.message ||
            "Something went wrong while loading candidates.",
        );

        setCandidates([]);
        setTotalCandidates(0);
      }
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCandidates();

  }, [
    status,
    sortConfig.key,
    sortConfig.direction,
    isSearching,
    isSearching ? null : currentPage,
    isSearching ? null : entriesPerPage,
  ]);

  const getStatusClassName = (status) => {
    switch (status) {
      case "Work in Progress":
        return "status-in-progress";

      case "Completed":
        return "status-bgc-completed";

      case "Verified":
        return "status-bgc-verified";

      case "Not Started":
        return "status-not-started";

      case "Pending":
        return "status-pending";

      default:
        return "";
    }
  };

  const getStatusClass = (status) => {
    if (!status) return "assigned-status-default";

    const normalized = status.toLowerCase();

    if (
      normalized.includes("pending") ||
      normalized.includes("expired") ||
      normalized.includes("work in progress")
    ) {
      return "assigned-status-orange";
    }

    if (normalized.includes("verified")) {
      return "assigned-status-blue";
    }

    if (normalized.includes("completed")) {
      return "assigned-status-green";
    }

    return "assigned-status-default";
  };

  const handleMailClick = async (candidateId) => {
    const candidateRequest = {
      newStatus: "VERIFIED",
    };

    try {
      setLoadingProfile(true);

      await updateCandidateStatus(candidateId, candidateRequest);

      /*
       * Candidate status changed.
       * Clear cached pages.
       */
      clearAssignedCandidatesCache();

      toast.success("Candidate Status updated successfully", {
        autoClose: 3000,
      });

      fetchCandidates();
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to verify personal background.";

      toast.error(errorMessage, {
        autoClose: 3000,
      });

      setError(errorMessage);
    } finally {
      setLoadingProfile(false);
    }
  };

  const handleStartBGC = (uniqueId) => {
    navigate(`/employee/candidateDetails/${uniqueId}`);
  };

  const handleViewDetails = (uniqueId) => {
    navigate(`/candidate-details/${uniqueId}`, {
      state: {
        heading: "Candidate Report",
        candidate: uniqueId,
      },
    });
  };

  /*
   * Server-side sorting.
   *
   * No frontend sorting.
   */
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }

      return {
        key,
        direction: "asc",
      };
    });
    setCurrentPage(1);
  };


  const filteredCandidates = useMemo(() => {
    if (!isSearching) return candidates;

    const term = trimmedSearch.toLowerCase();

    return candidates.filter((candidate) =>
      [candidate.uniqueId, candidate.name, candidate.email, candidate.status]
        .map((value) => String(value ?? "").toLowerCase())
        .some((value) => value.includes(term)),
    );
  }, [candidates, isSearching, trimmedSearch]);

  const totalRecords = isSearching
    ? filteredCandidates.length
    : totalCandidates;

  const totalPages = Math.ceil(totalRecords / entriesPerPage);
  const currentEntries = useMemo(() => {
    if (!isSearching) return filteredCandidates;

    const start = (currentPage - 1) * entriesPerPage;

    return filteredCandidates.slice(start, start + entriesPerPage);
  }, [filteredCandidates, isSearching, currentPage, entriesPerPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));

    setCurrentPage(1);
  };

  const SortIcon = ({ column }) => {
    const isActive = sortConfig.key === column;

    if (!isActive) {
      return (
        <span
          style={{
            display: "inline-flex",
            flexDirection: "column",
            fontSize: "10px",
            lineHeight: "0.85",
            marginLeft: "6px",
            verticalAlign: "middle",
            color: "rgba(255, 255, 255, 0.4)",
            userSelect: "none",
          }}
        >
          <span>▲</span>

          <span
            style={{
              marginTop: "1px",
            }}
          >
            ▼
          </span>
        </span>
      );
    }

    return (
      <span
        style={{
          display: "inline-block",
          fontSize: "11px",
          marginLeft: "6px",
          color: "#ffffff",
          fontWeight: "bold",
          verticalAlign: "middle",
          userSelect: "none",
        }}
      >
        {sortConfig.direction === "asc" ? "▲" : "▼"}
      </span>
    );
  };

  // pagination page number counter .
  const getPaginationPages = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages + 2) {
      // Show all pages when the total is small
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show the first page
      pages.push(1);

      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Adjust the range near the beginning
      if (currentPage <= 3) {
        startPage = 2;
        endPage = 4;
      }

      // Adjust the range near the end
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - 3;
        endPage = totalPages - 1;
      }

      if (startPage > 2) {
        pages.push("...");
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push("...");
      }

      // Always show the last page
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="dashboard-app-container">
      <Sidebar />

      <div className="assigned-dashboard-right-panel">
        <TopNavbar />

        <div className="content-area-wrapper">
          {loadingProfile && (
            <div className="centered-message">
              <div className="spinner"></div>

              <div>Sending Mail...</div>
            </div>
          )}

          <main className="assigned-main-content">
            <button
              type="button"
              className="assigned-candidates-back-button"
              onClick={() => navigate('/employee/dashboard')}
            >
              <ArrowLeft size={18} />

              <span>Back</span>
            </button>

            <h2 className="assigne-candidate-list-header">
              Assigned Candidates List
            </h2>

            <section className="assigne-candidate-section">
              <div className="table-controls">
                <label className="entries-label">
                  Entries per page:
                  <select
                    value={entriesPerPage}
                    onChange={handleEntriesPerPageChange}
                    className="show-entries-dropdown"
                  >
                    <option value={10}>10</option>

                    <option value={25}>25</option>

                    <option value={50}>50</option>

                    <option value={100}>100</option>
                  </select>
                </label>

                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search candidates..."
                    className="search-bar-input"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);

                      /*
                       * Search starts from page 1.
                       */
                      setCurrentPage(1);
                    }}
                  />

                  <span className="search-bar-icon">
                    <CiSearch />
                  </span>
                </div>
              </div>

              {loading ? (
                <p className="loading-message">Loading candidates...</p>
              ) : error ? (
                <p className="error-message">{error}</p>
              ) : (
                <>
                  <div className="assigne-candidate-table-container">
                    <table className="assigne-candidate-table">
                      <thead>
                        <tr>
                          <th
                            className="ascend-candidates-sortable"
                            onClick={() => handleSort("uniqueId")}
                          >
                            Candidate ID <SortIcon column="uniqueId" />
                          </th>

                          <th
                            className="ascend-candidates-sortable"
                            onClick={() => handleSort("name")}
                          >
                            Name <SortIcon column="name" />
                          </th>

                          <th
                            className="ascend-candidates-sortable"
                            onClick={() => handleSort("email")}
                          >
                            Email <SortIcon column="email" />
                          </th>

                          <th
                            className="ascend-candidates-sortable"
                            onClick={() => handleSort("status")}
                          >
                            Status <SortIcon column="status" />
                          </th>

                          <th>Verification</th>

                          <th
                            style={{
                              textAlign: "center",
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentEntries.length > 0 ? (
                          currentEntries.map((candidate) => (
                            <tr key={candidate.uniqueId}>
                              <td>{candidate.uniqueId}</td>

                              <td>{candidate.name}</td>

                              <td>{candidate.email}</td>

                              <td>
                                <span
                                  className={`assigned-status-badge ${getStatusClass(
                                    candidate.status,
                                  )}`}
                                >
                                  {candidate.status}
                                </span>
                              </td>

                              <td className="text-center align-middle">
                                <button
                                  className="start-bgc-button w-100"
                                  onClick={() =>
                                    handleStartBGC(candidate.uniqueId)
                                  }
                                  disabled={isBGCButtonDisabled(
                                    candidate.status,
                                  )}
                                >
                                  {getBGCButtonLabel(candidate.status)}
                                </button>
                              </td>

                              <td>
                                <div className="action-buttons-group">
                                  <button
                                    type="button"
                                    className="action-button view-button"
                                    style={{
                                      color: "#4D0054",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();

                                      e.stopPropagation();

                                      handleViewDetails(candidate.uniqueId);
                                    }}
                                    title="View Details"
                                  >
                                    <FaEye />
                                  </button>

                                  <button
                                    className="action-button mail-button"
                                    onClick={() =>
                                      handleMailClick(candidate.id)
                                    }
                                    title="Send Mail"
                                    disabled={isMailButtonDisabled(candidate)}
                                  >
                                    <img
                                      src={mailIcon}
                                      alt="Send Mail"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        opacity:
                                          candidate.status === "Completed" ||
                                          candidate.status === "Verified"
                                            ? 1
                                            : 1.5,
                                      }}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="no-data">
                              No candidates found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}

                  <div className="pagination-container">
                    <div className="pagination-info">
                      Showing{" "}
                      {totalRecords === 0
                        ? 0
                        : (currentPage - 1) * entriesPerPage + 1}{" "}
                      to {Math.min(currentPage * entriesPerPage, totalRecords)}{" "}
                      of {totalRecords} entries
                    </div>

                    <div className="pagination-buttons">
                      {/* Previous Button */}

                      <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1 || loading}
                      >
                        Previous
                      </button>

                      {/* Page Numbers */}

                      {getPaginationPages().map((page, index) =>
                        page === "..." ? (
                          <span
                            key={`ellipsis-${index}`}
                            className="pagination-ellipsis"
                          >
                            ...
                          </span>
                        ) : (
                          <button
                            key={page}
                            className={`pagination-button ${
                              currentPage === page ? "active" : ""
                            }`}
                            onClick={() => handlePageChange(page)}
                            disabled={loading}
                          >
                            {page}
                          </button>
                        ),
                      )}

                      {/* Next Button */}

                      <button
                        className="pagination-button"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={
                          currentPage >= totalPages ||
                          totalPages === 0 ||
                          loading
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              )}
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AssignedCandidatesList;